import { H as u, ft as m, b as i } from "./abstract-base-CzLmw6_x-Ds3dPjNU.js";
import { r as v } from "./cta-variant-SwPVCQO_-Cf2MRz8Z.js";
import { m as p } from "./tracks-default-slot-Bh3fauEa-rA06gEzV.js";
import { t as f } from "./beacon-primitive-ChVMWFlW-Df2Js5lw.js";
import { N as g, A as y } from "./query-assigned-K46zQIzj-dGW7AjV_.js";
import { C as w } from "./form-associated-BsQdIDHG-DR1vCHm2.js";
import { a as S } from "./lifecycle-decorators-CUsT9aHq-Dtp3uB6c.js";
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
function U(t, o, e) {
  return t ? o(t) : e == null ? void 0 : e(t);
}
var h = /* @__PURE__ */ ((t) => (t.LOADING = "loading", t.PROGRESS = "progress", t.SUCCESS = "success", t.RESULT = "result", t.NONE = "", t))(h || {}), d = /* @__PURE__ */ ((t) => (t.SUBMIT = "submit", t.BUTTON = "button", t.RESET = "reset", t.MENU = "menu", t))(d || {});
const k = u`[beacon-tag-name=beacon-button][icon-align=left]{--beacon-button-icon-align: start}.beacon-button-icon{align-self:var(--beacon-button-icon-align, center)}.beacon-button-icon .beacon-button-icon--icon{fill:currentcolor}.beacon-button-icon .beacon-button-icon--stroke{stroke:currentcolor}[beacon-tag-name=beacon-icon-button] .beacon-button-icon{block-size:var(--override-icon-button-block-size, var(--beacon-reference-space-7, calc(1.5 * var(--beacon-unit-base))));inline-size:var(--override-icon-button-inline-size, var(--beacon-reference-space-7, calc(1.5 * var(--beacon-unit-base))))}`, x = u`:host([motion-state=enabled]) a,:host([motion-state=enabled]) button,:host([motion-state=enabled]) .icon-button{--button-base-transition-property: background-color;transition-duration:var(--button-base-transition-duration, 0s);transition-property:var(--button-base-transition-property);transition-timing-function:var(--button-base-transition-timing-function, var(--beacon-system-motion-easing-decelerate-emphasize-1))}:host([motion-state=enabled]) a .contents,:host([motion-state=enabled]) button .contents,:host([motion-state=enabled]) .icon-button .contents{transition-duration:inherit;transition-property:transform;transition-timing-function:inherit}`;
var E = (t, o, e, b) => {
  for (var r = o, s = t.length - 1, c; s >= 0; s--)
    (c = t[s]) && (r = c(r) || r);
  return r;
};
const O = () => function(t) {
  let o = class extends t {
    static get ButtonBaseMotionStyles() {
      return [x];
    }
  };
  return o = E([
    S("ButtonBaseMotion")
  ], o), o;
}, T = u`:is(button,a):focus-visible{--heritage-width-border-normal: calc(var(--beacon-unit-base) / 8);--heritage-width-border-jumbo: calc(var(--beacon-unit-base) / 4);--heritage-width-border-maxi: calc(var(--beacon-unit-base) / 2);--total-ring-width: calc(var(--beacon-system-width-border-jumbo, var(--heritage-width-border-jumbo)) + var(--beacon-system-width-border-maxi, var(--heritage-width-border-maxi)) + var(--beacon-system-width-border-normal, var(--heritage-width-border-normal)));box-shadow:0 0 0 var(--beacon-system-width-border-jumbo, var(--heritage-width-border-jumbo)) var(--beacon-system-color-border-focus-middle, var(--beacon-color-outline-focus)),0 0 0 var(--beacon-system-width-border-maxi, var(--heritage-width-border-maxi)) var(--beacon-system-color-border-focus-outer, var(--beacon-color-shadow-focus));outline:var(--beacon-system-width-border-normal, var(--heritage-width-border-normal)) solid var(--beacon-system-color-border-focus-inner, var(--beacon-color-border-focus));outline-offset:0;position:relative;z-index:1}:is(button,a).tertiary:focus-visible{--second-ring-width: calc(var(--beacon-system-width-border-jumbo, var(--heritage-width-border-jumbo)) + var(--beacon-system-width-border-normal, var(--heritage-width-border-normal)));--heritage-width-border-normal: calc(var(--beacon-unit-base) / 8);--heritage-width-border-jumbo: calc(var(--beacon-unit-base) / 4);--heritage-width-border-maxi: calc(var(--beacon-unit-base) / 2);--total-ring-width: calc(var(--beacon-system-width-border-jumbo, var(--heritage-width-border-jumbo)) + var(--beacon-system-width-border-maxi, var(--heritage-width-border-maxi)) + var(--beacon-system-width-border-normal, var(--heritage-width-border-normal)));box-shadow:0 0 0 var(--second-ring-width) var(--beacon-system-color-border-focus-outer, var(--beacon-color-shadow-focus));outline:var(--beacon-system-width-border-normal, var(--heritage-width-border-normal)) solid var(--beacon-system-color-border-focus-middle, var(--beacon-color-outline-focus));outline-offset:0;position:relative;z-index:1}`;
var N = Object.defineProperty, a = (t, o, e, b) => {
  for (var r = void 0, s = t.length - 1, c; s >= 0; s--)
    (c = t[s]) && (r = c(o, e, r) || r);
  return r && N(o, e, r), r;
};
const l = {
  icon: "beacon-button-icon",
  strokeFill: "beacon-button-icon--stroke",
  iconFill: "beacon-button-icon--icon"
}, j = "stroke";
class n extends f(w, O(), p({ clean: !0 })) {
  constructor() {
    super(...arguments), this.focusOverride = !0, this.SLOTTED_ICON_INDEX = 0, this.type = d.BUTTON, this.variant = v.PRIMARY, this.state = h.NONE, this.disabled = !1, this.linkHref = "";
  }
  static get styles() {
    return [super.styles, T, this.ButtonBaseMotionStyles];
  }
  static get lightDOMStyles() {
    return [super.lightDOMStyles, k];
  }
  /**
   * Returns the first element in the icon slot
   */
  get icon() {
    return this.iconElements[this.SLOTTED_ICON_INDEX];
  }
  /**
   * Event listener for internal HTML button that
   * determines click behavior depending on its disabled state
   * and button type.
   * @param event click event
   * @event {BeaconEvents} beacon-event-click - Emits when clicked
   */
  handleClick(o) {
    this.disabled ? (o.preventDefault(), o.stopPropagation(), o.stopImmediatePropagation()) : (this.emitClick(o), this.internals && this.type === d.SUBMIT && this.internals.form.requestSubmit());
  }
  /**
   * Applies proper CSS class to slotted SVG such that it renders correctly
   * @param element reference to the slotted SVG
   */
  applySVGClass(o) {
    o && Array.from(o.children).forEach((e) => {
      if (e) {
        const b = e.getAttribute(j) ? l.strokeFill : l.iconFill;
        e.classList.add(b);
      }
    });
  }
  handleIconSlotchange() {
    var o;
    if (this.icon) {
      this.icon.classList.add(l.icon);
      const e = (o = this.label) != null ? o : this.defaultSlotText;
      m(this.icon, e), this.applySVGClass(this.icon);
    }
  }
}
a([
  i({ reflect: !0 })
], n.prototype, "type");
a([
  i({ alternateSlot: "default", sync: !1 })
], n.prototype, "label");
a([
  i()
], n.prototype, "variant");
a([
  i()
], n.prototype, "state");
a([
  i({ type: Boolean })
], n.prototype, "disabled");
a([
  i({ attribute: "link-href" })
], n.prototype, "linkHref");
a([
  i({ attribute: "link-download" })
], n.prototype, "linkDownload");
a([
  i({ attribute: "link-target" })
], n.prototype, "linkTarget");
a([
  g({ flatten: !0, slot: "icon", selector: "svg" })
], n.prototype, "iconElements");
a([
  y("button, a")
], n.prototype, "button");
export {
  U as L,
  n
};
